import { createSvgComponent } from "../../icon/createSvgComponent";
import Alarm from "@core/icon/assets/alarm.svg";
export default createSvgComponent(Alarm);